const UserCenter = () => import('Views/user/user-center-new-ui');
const UserInfo = () => import('Views/user/user-info-new-ui');
const EmailConfirm = () => import('Views/user/email-confirm');

export default[
  { path: '/user-center', component: UserCenter },
  { path: '/user-info', component: UserInfo },
  { path: '/email-confirm', component: EmailConfirm },
];



// WEBPACK FOOTER //
// ./src/router/user.js